import { formatOrAnonymize } from "./format-or-anonymize";

const formatter = new Intl.NumberFormat('de-DE');

export function toNumDE(value?: number | string | null): string {
  const deNumOrAnonymized = formatOrAnonymize(value, (value) => formatter.format(+value))
  return deNumOrAnonymized;
}